const POCET_MESIACOV_V_ROKU = 12;

function cislo(hodnota) {
  const vysledok = Number(hodnota);
  return Number.isFinite(vysledok)
    ? vysledok
    : 0;
}

function nezaporneCislo(hodnota) {
  return Math.max(
    0,
    cislo(hodnota)
  );
}

function vypocitajRealnuHodnotu(
  hodnota,
  inflacia,
  mesiac
) {
  const inflaciaPercento =
    nezaporneCislo(inflacia);

  if (inflaciaPercento <= 0) {
    return nezaporneCislo(hodnota);
  }

  return (
    nezaporneCislo(hodnota) /
    Math.pow(
      1 + inflaciaPercento / 100,
      nezaporneCislo(mesiac) /
        POCET_MESIACOV_V_ROKU
    )
  );
}

function vypocitajVplyvPoplatkov({
  bod,
  bodBezPoplatkov,
  mesiac,
  zhodnotenie,
  externyJednorazovyPoplatok,
}) {
  const rozdielPriebehov =
    Math.max(
      0,
      nezaporneCislo(
        bodBezPoplatkov?.hodnota
      ) -
        nezaporneCislo(
          bod?.hodnota
        )
    );

  if (
    externyJednorazovyPoplatok <= 0
  ) {
    return rozdielPriebehov;
  }

  const mesacneZhodnotenie =
    Math.pow(
      1 +
        nezaporneCislo(
          zhodnotenie
        ) /
          100,
      1 / POCET_MESIACOV_V_ROKU
    ) - 1;

  const buducaHodnotaExternehoPoplatku =
    externyJednorazovyPoplatok *
    Math.pow(
      1 + mesacneZhodnotenie,
      mesiac
    );

  return (
    rozdielPriebehov +
    buducaHodnotaExternehoPoplatku
  );
}

function vytvorMesacneRiadky(
  vysledok,
  nastavenia
) {
  const priebeh =
    Array.isArray(
      vysledok?.priebeh
    )
      ? vysledok.priebeh
      : [];

  const priebehBezPoplatkov =
    Array.isArray(
      vysledok
        ?.priebehBezPoplatkov
    )
      ? vysledok
          .priebehBezPoplatkov
      : [];

  const pociatocnyJednorazovyVklad =
    nezaporneCislo(
      nastavenia
        ?.jednorazovyVklad
    );

  const externyJednorazovyPoplatok =
    nastavenia?.typPoplatku ===
    "jednorazovy"
      ? nezaporneCislo(
          nastavenia
            ?.jednorazovyPoplatok
        )
      : 0;

  const inflacia =
    nezaporneCislo(
      vysledok?.inflacia
    );

  const zhodnotenie =
    nezaporneCislo(
      vysledok?.zhodnotenie
    );

  return priebeh.map(
    (bod, index) => {
      const predoslyBod =
        index > 0
          ? priebeh[index - 1]
          : null;

      const mesiac = Math.max(
        1,
        Math.floor(
          cislo(bod?.mesiac) ||
            index + 1
        )
      );

      const pravidelnyVklad =
        nezaporneCislo(
          bod?.pravidelnyVklad
        );

      const privklad =
        nezaporneCislo(
          bod?.jednorazovyPrivklad
        );

      const jednorazovyVklad =
        privklad +
        (
          index === 0
            ? pociatocnyJednorazovyVklad
            : 0
        );

      const poplatky = Math.max(
        0,
        nezaporneCislo(
          bod?.poplatky
        ) -
          nezaporneCislo(
            predoslyBod?.poplatky
          )
      );

      const externyPoplatok =
        index === 0
          ? externyJednorazovyPoplatok
          : 0;

      const jeDodatocneZhodnocovanie =
        Boolean(
          bod
            ?.jeDodatocneZhodnocovanie
        );

      const jeZaciatokDodatocnehoZhodnocovania =
        jeDodatocneZhodnocovanie &&
        !Boolean(
          predoslyBod
            ?.jeDodatocneZhodnocovanie
        );

      return {
        key: `mesiac-${mesiac}`,
        obdobie: mesiac,
        mesiacOd: mesiac,
        mesiacDo: mesiac,
        pravidelnyVklad,
        privklad,
        jednorazovyVklad,
        vklady:
          pravidelnyVklad +
          jednorazovyVklad,
        zhodnotenie: cislo(
          bod
            ?.zhodnotenieVMesiaci
        ),
        poplatky,
        externyPoplatok,
        vplyvPoplatkov:
          vypocitajVplyvPoplatkov({
            bod,
            bodBezPoplatkov:
              priebehBezPoplatkov[
                index
              ],
            mesiac,
            zhodnotenie,
            externyJednorazovyPoplatok,
          }),
        hodnotaInvesticie:
          nezaporneCislo(
            bod?.hodnota
          ),
        realnaHodnota:
          vypocitajRealnuHodnotu(
            bod?.hodnota,
            inflacia,
            mesiac
          ),
        jeDodatocneZhodnocovanie,
        jeZaciatokDodatocnehoZhodnocovania,
      };
    }
  );
}

function agregujRiadkyPoRokoch(
  mesacneRiadky
) {
  const rocneRiadky = [];

  for (
    let index = 0;
    index < mesacneRiadky.length;
    index += POCET_MESIACOV_V_ROKU
  ) {
    const riadkyRoka =
      mesacneRiadky.slice(
        index,
        index +
          POCET_MESIACOV_V_ROKU
      );

    if (!riadkyRoka.length) {
      continue;
    }

    const poslednyRiadok =
      riadkyRoka[
        riadkyRoka.length - 1
      ];

    const rok =
      Math.floor(
        index /
          POCET_MESIACOV_V_ROKU
      ) + 1;

    rocneRiadky.push({
      key: `rok-${rok}`,
      obdobie: rok,
      mesiacOd:
        riadkyRoka[0].mesiacOd,
      mesiacDo:
        poslednyRiadok.mesiacDo,

       pravidelnyVklad:
        riadkyRoka.reduce(
          (
            sucet,
            riadok
          ) =>
            sucet +
            riadok.pravidelnyVklad,
          0
        ),

      privklad:
        riadkyRoka.reduce(
          (
            sucet,
            riadok
          ) =>
            sucet +
            riadok.privklad,
          0
        ),

      jednorazovyVklad:
        riadkyRoka.reduce(
          (
            sucet,
            riadok
          ) =>
            sucet +
            riadok.jednorazovyVklad,
          0
        ),

      vklady:
        riadkyRoka.reduce(
          (
            sucet,
            riadok
          ) =>
            sucet +
            riadok.vklady,
          0
        ),

      zhodnotenie:
        riadkyRoka.reduce(
          (
            sucet,
            riadok
          ) =>
            sucet +
            riadok.zhodnotenie,
          0
        ),

      poplatky:
        riadkyRoka.reduce(
          (
            sucet,
            riadok
          ) =>
            sucet +
            riadok.poplatky,
          0
        ),

      externyPoplatok:
        riadkyRoka.reduce(
          (
            sucet,
            riadok
          ) =>
            sucet +
            riadok.externyPoplatok,
          0
        ),

      vplyvPoplatkov:
        poslednyRiadok
          .vplyvPoplatkov,

      hodnotaInvesticie:
        poslednyRiadok
          .hodnotaInvesticie,

      realnaHodnota:
        poslednyRiadok
          .realnaHodnota,

      jeDodatocneZhodnocovanie:
        riadkyRoka.every(
          (riadok) =>
            riadok
              .jeDodatocneZhodnocovanie
        ),

      jeZaciatokDodatocnehoZhodnocovania:
        riadkyRoka.some(
          (riadok) =>
            riadok
              .jeZaciatokDodatocnehoZhodnocovania
        ),
    });
  }

  return rocneRiadky;
}

export function vytvorRiadkyVyvojaInvesticie({
  vysledok,
  nastavenia,
  rezim,
}) {
  const mesacneRiadky =
    vytvorMesacneRiadky(
      vysledok,
      nastavenia
    );

  return rezim === "roky"
    ? agregujRiadkyPoRokoch(
        mesacneRiadky
      )
    : mesacneRiadky;
}

export function maVyvojInvesticiePoplatky(
  riadky
) {
  return (
    Array.isArray(riadky) &&
    riadky.some(
      (riadok) =>
        cislo(
          riadok?.poplatky
        ) > 0 ||
        cislo(
          riadok?.externyPoplatok
        ) > 0 ||
        cislo(
          riadok?.vplyvPoplatkov
        ) > 0
    )
  );
}